import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { UserCircle, ArrowLeft } from 'lucide-react'
import { FamilyContext } from '../Context/FamilyHeadContext'
import { API_URL } from '../services/apiService'

const Page404 = () => {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()

    const {
        familyHeadsBazach,
        familyHeadsHumenir,
        huminerMain,
        bazachMain,
        loading
    } = useContext(FamilyContext)

    const getModifiedHeads = (heads, isHuminer) => {
        return heads.map((head) => ({
            ...head,
            path:
                head.gedId === (isHuminer ? huminerMain?.gedId : bazachMain?.gedId)
                    ? isHuminer
                        ? `/${i18n.language}/huminer`
                        : `/${i18n.language}/`
                    : isHuminer
                        ? `/${i18n.language}/huminer/${head.nickname}`
                        : `/${i18n.language}/${head.nickname}`,
        }))
    }

    const handleSelectFamilyHead = (head) => {
        navigate(head.path, { replace: true })
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center p-2">
                <div className="w-5 h-5 border-2 border-[#8B5E3C] border-t-transparent rounded-full animate-spin" />
            </div>
        )
    }

    const renderFamilyGroup = (heads, isHuminer) => {
        const modifiedHeads = getModifiedHeads(heads, isHuminer)
        return (
            <div className="mb-8">
                <h2 className="text-2xl font-bold text-[#5C4033] mb-4">
                    {isHuminer ? t('page404.huminerTitle') : t('page404.bazachTitle')}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {modifiedHeads.map((head) => (
                        <div
                            key={head.gedId}
                            onClick={() => handleSelectFamilyHead(head)}
                            className="bg-white rounded-lg shadow-md p-6 flex flex-col hover:shadow-lg transition-shadow cursor-pointer"
                        >
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-xl font-bold text-[#5C4033]">{head.name}</h3>
                                <div className="flex-shrink-0">
                                    {head.images?.[0]?.key ? (
                                        <img
                                            crossOrigin="use-credentials"
                                            src={`${API_URL}/image/download/${encodeURIComponent(
                                                head.images[0].key,
                                            )}`}
                                            alt={head.name}
                                            className="w-16 h-16 rounded-full object-cover"
                                        />
                                    ) : (
                                        <UserCircle className="w-16 h-16 text-[#8B5E3C]" />
                                    )}
                                </div>
                            </div>
                            {head.title && (
                                <p className="text-sm text-[#8B5E3C] mb-2">{head.title}</p>
                            )}
                            <div className="flex items-center gap-2 text-[#8B5E3C] mt-auto">
                                <span>{t('page404.viewProfile')}</span>
                                <ArrowLeft className="w-4 h-4" />
                            </div>
                            {head.isMain && (
                                <div className="mt-2">
                                    <span className="text-xs bg-[#E6D5C1] text-[#5C4033] px-2 py-1 rounded-full">
                                        {t('mainLineage.isMain')}
                                    </span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="text-center mb-12">
                <h1 className="text-3xl font-heebo font-bold text-[#5C4033] mb-4">
                    {t('page404.title')}
                </h1>
                <p className="text-lg text-[#8B5E3C]">
                    {t('page404.description')}
                </p>
                <p className="text-xl font-bold text-[#5C4033] mt-8">
                    {t('page404.findFamily')}
                </p>
            </div>

            {renderFamilyGroup(familyHeadsBazach, false)}
            {renderFamilyGroup(familyHeadsHumenir, true)}
        </div>
    )
}

export default Page404